import * as t from "io-ts"
import useSWR from "swr"

import { tsIoValidate } from "../../../../utils/general/generalUtils"
import { getClientProtected } from "../../clients/clients"
import { NO_REVALIDATE_CONFIG } from "../../swrConfig"
import { IS_DOMAIN_CLAIMABLE } from "../../urls/private"

const DomainClaimable = t.type({
    domain_is_claimable: t.boolean,
})
type TDomainClaimable = t.TypeOf<typeof DomainClaimable>

interface IUseCanClaimDomain {
    isCheckingDomain: boolean
    canClaimDomain: undefined | boolean
}

/**
 * Checks if a given user has any pending invites. If the call fails,
 * by default, the domain is claimable. The backend APIs will catch this.
 * @returns {IUseCanClaimDomain} - loading and error states.
 */
const useCanClaimDomain = (): IUseCanClaimDomain => {
    const { isLoading, data } = useSWR(
        IS_DOMAIN_CLAIMABLE,
        async (url: string): Promise<boolean> => {
            try {
                const res = await getClientProtected(url)
                const resChecked = tsIoValidate<TDomainClaimable>(
                    DomainClaimable,
                    res,
                    "Invalid domain claimable format received"
                )
                return resChecked.domain_is_claimable
            } catch (err) {
                return true
            }
        },
        NO_REVALIDATE_CONFIG
    )

    return {
        canClaimDomain: data,
        isCheckingDomain: isLoading,
    }
}

export default useCanClaimDomain
